import React from 'react'

const About = () => {
  return (
    <div style={{marginTop:"150px"}}>
      <h2>
        {" "}
        This is the React Firebase CRUD Application. This application is used to Managing Contact more efficiently.
      </h2>
      <h4 style={{marginTop:"70px", color:"#009879"}}>
      &copy; 2024 ZJ Developer. All rights reserved.
      </h4>
    </div>
  )
}

export default About